import { memo } from 'react';
import { ChoiceSelect, type Choice } from '@/components/ui/choice-select';

/**
 * The supplier's «Paese»: some 250 countries. Memoized, so a key typed in another field of the
 * dialog does not render them all again, and opened below the trigger, so a click that lands while
 * the list mounts picks nothing (#986). 44 px tall, like the create dialog's (look check of change 90).
 */
export const CountrySelect = memo(function CountrySelect({
  id,
  value,
  choices,
  onChange,
}: {
  readonly id: string;
  readonly value: string;
  readonly choices: readonly Choice[];
  readonly onChange: (country: string) => void;
}) {
  return (
    <ChoiceSelect
      triggerClassName="data-[size=default]:min-h-11"
      position="popper"
      id={id}
      value={value}
      choices={choices}
      onChange={onChange}
    />
  );
});
